import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class DesignerProvider extends HttpRequest {
  constructor () {
    super(process.env.VUE_APP_MER_API)
  }

  getAll () {
    this.setHeader(getAuthToken())
    return this.get('/designers?page=1&limit=9999999&sort_by=name&sort_order=asc')
  }

  getOne (id) {
    this.setHeader(getAuthToken())
    return this.get(`/designers/${id}`)
  }

  createOne (form) {
    this.setHeader(getAuthToken())
    return this.post('/designers', form)
  }

  updateOne (id, form) {
    this.setHeader(getAuthToken())
    return this.post(`/designers/${id}`, form)
  }

  deleteOne (id) {
    this.setHeader(getAuthToken())
    return this.get(`/designers/${id}`)
  }
}

export default DesignerProvider
